module.exports = __webpack_public_path__ + "img/so.258cf0ab.svg";